import apiUrl from '../../../constants'
import axios from 'axios'
export default new class {

	async validateBox(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'splitshipment/validateBoxForSplit',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async splitShipmentGeneric(input, token) {
		
		try {
			let result= await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'splitshipment/splitShipmentGeneric',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			 return err.response;
		}
	};
	async splitBoxPacking(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'splitBoxPacking',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async getSplitBoxDetails(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'packing/getSplitBoxDetails',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};


	async completeBoxPacking(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'packing/completeBoxPacking',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async getrubiconInvoiceAndLabel(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'packing/getrubiconInvoiceAndLabel',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async getInvoiceWMS(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'getinvoicedata',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async getUnicommerceInvoiceAndLabel(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'packing/getUnicommerceInvoiceAndLabel',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async getFlipkartInvoiceAndLabel(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'packing/getFlipkartInvoiceAndLabel',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async getBoxDetails(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'packing/getBoxDetails',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async scanProductPacking(input, token,isSplit = 0) {
		try {
			let url ='packing/scanProductPacking'
			if(isSplit == 1){
               url = 'splitshipment/validateboxproduct'
			}
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + url,
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async changeBoxStatus(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'packing/changeBoxStatus',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async updateQcDetails(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'packing/packingProductQC',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async getWarehouseList(token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
				'data': {},
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

	async getWeight(token) {
		try {
			let result = await axios({
				'method': 'GET',
				'url': apiUrl.local_printer_api_url + 'getWeight',
				'data': {},
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getpackingboxflag(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'packing/checkpackingboxflag',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getPackingBox(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'getPackingBox',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getPackingSuggestBox(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'getPackingBoxSuggession',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getSuggestedPackingDetail(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'getSuggestedPackingDetails',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async SaveBoxSugestion(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'updatePackingBoxData',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getEancodeFlag(input, token) {
		try {
			let result = await axios({
				'method': 'POST',
				'url': apiUrl.api_url + 'checkEancodeManualEntry',
				'data': input,
				'headers': {
					'Authorization': 'Bearer ' + token,
				}
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};

}



// WEBPACK FOOTER //
// ./src/views/components/packingnew/packingapis.js